import { itemApi } from '../api/itemApi';
import { Item, ItemFormData, ItemListResponse, ItemFilterParams } from '../types/item.types';

class ItemService {
  /**
   * Get paginated list of items
   */
  async getItems(params: ItemFilterParams): Promise<ItemListResponse> {
    return itemApi.getItems(params);
  }

  /**
   * Get a single item by ID
   */
  async getItemById(id: string): Promise<Item> {
    return itemApi.getItemById(id);
  }

  /**
   * Create a new item
   */
  async createItem(data: ItemFormData): Promise<Item> {
    return itemApi.createItem(data);
  }

  /**
   * Update an existing item
   */
  async updateItem(id: string, data: Partial<ItemFormData>): Promise<Item> {
    return itemApi.updateItem(id, data);
  }

  /**
   * Delete an item (soft delete)
   */
  async deleteItem(id: string): Promise<void> {
    await itemApi.deleteItem(id);
  }

  /**
   * Toggle item active status
   */
  async toggleItemStatus(id: string, isActive: boolean): Promise<Item> {
    return itemApi.toggleItemStatus(id, isActive);
  }

  /**
   * Check if item code already exists
   */
  async checkItemCodeExists(itemCode: string, excludeId?: string): Promise<boolean> {
    return itemApi.checkItemCodeExists(itemCode, excludeId);
  }
  /**
   * Import items in bulk (CSV)
   */
  async importItems(items: any[]): Promise<void> {
    return itemApi.importItems(items);
  }
}

export const itemService = new ItemService();
export default itemService;
